/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';

import { isUnauthorizedError } from '@confluence/error-boundary';
import { markErrorAsHandled } from '@confluence/graphql';

import type { AdminKeyEligibilityQueryAdminKeyEligibilityQuery as AdminKeyEligibilityQueryAdminKeyEligibilityQuery$data } from './__types__/AdminKeyEligibilityQueryAdminKeyEligibilityQuery';

export function AdminKeyEligibilityQuery({ children }) {
	const { data, error, loading } = useQuery<AdminKeyEligibilityQueryAdminKeyEligibilityQuery$data>(
		gql`
			query AdminKeyEligibilityQueryAdminKeyEligibilityQuery {
				tenant {
					cloudId
					editions {
						edition
					}
				}
				user(current: true) {
					id
					confluence {
						roles {
							canBeSuperAdmin
						}
					}
				}
			}
		`,
	);

	let errorToReportToChildren: typeof error;
	if (error) {
		if (isUnauthorizedError(error)) {
			// If `edition` is not permitted to the current user (e.g. anonymous
			// access is not permitted), then the current user is definitely not
			// eligible for admin key. So here an unauthorized error is an expected
			// error.
			markErrorAsHandled(error);
		} else {
			errorToReportToChildren = error;
		}
	}

	return children({
		canBeSuperAdmin: Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin),
		edition: data?.tenant?.editions?.edition,
		error: errorToReportToChildren,
		loading,
	});
}

AdminKeyEligibilityQuery.propTypes = {
	children: PropTypes.func.isRequired,
};
